import React from 'react';

const ConditionsUtilisation = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 py-12">
      <div className="max-w-5xl mx-auto px-4">
        <header className="mb-12">
          <h1 className="text-4xl font-display font-bold text-primary-900 dark:text-primary-300 mb-4">Conditions d'utilisation</h1>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl">Merci de lire attentivement ces conditions qui encadrent votre utilisation de la Plateforme Village Artisanal.</p>
        </header>

        <div className="space-y-10">
          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Objet</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">La Plateforme met en relation des artisans et des visiteurs pour la découverte et l'achat potentiel de créations artisanales.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Création de compte</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">L'utilisateur s'engage à fournir des informations exactes et à les mettre à jour si nécessaire. La Plateforme peut suspendre les comptes en cas d'abus ou de fraude.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Comportement</h2>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2">
              <li>Ne pas publier de contenu illicite, diffamatoire ou offensant.</li>
              <li>Publier que des articles artisanaux made in Sénégal.</li>
              <li>Respecter les droits de propriété intellectuelle des tiers.</li>
              <li>Ne pas tenter d'altérer le fonctionnement technique du site.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Produits & Transactions</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Les artisans sont seuls responsables des descriptions, prix et disponibilités des produits qu'ils publient. Les modalités d'achat, de livraison ou de paiement peuvent être gérées par des canaux externes intégrés, selon évolution future.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Sécurité</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Des mesures raisonnables sont mises en œuvre pour protéger les données et accès. L'utilisateur doit garder son mot de passe confidentiel.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Suspension & Résiliation</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Nous pouvons suspendre l'accès en cas de violation des présentes conditions ou d'utilisation malveillante. L'utilisateur peut demander la suppression de son compte à tout moment.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Limitation de responsabilité</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">La Plateforme ne garantit pas l'absence totale d'erreurs ou d'interruptions. Elle ne saurait être tenue responsable des dommages indirects liés à l'utilisation.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Modification</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Les présentes conditions peuvent être modifiées pour refléter des évolutions légales ou techniques. La date de mise à jour est indiquée ci-dessous.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Contact</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Pour toute question concernant ces conditions : <a href="mailto:legal@villageartisanal.sn" className="text-accent-600 dark:text-accent-400 hover:underline">legal@villageartisanal.sn</a></p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Date</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Dernière mise à jour : {new Date().toLocaleDateString()}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ConditionsUtilisation;
